(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selectTopicFromHash = () => {
      if (!location.hash.startsWith('#topic-')) return;
      const pill = document.getElementById(location.hash.slice(1));
      const input = pill?.querySelector('input[type="radio"]');
      if (!input) return;
      input.checked = true;
      document.getElementById('ContactForm-body')?.focus({ preventScroll: true });
    };

    selectTopicFromHash();
    window.addEventListener('hashchange', selectTopicFromHash);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion-hero"] && !Shopify.designMode) return;
  try {
    
  class PromotionCountdown extends HTMLElement {
    connectedCallback() {
      this.ends = Number(this.dataset.ends);
      this.units = {
        days: this.querySelector('[data-unit="days"]'),
        hours: this.querySelector('[data-unit="hours"]'),
        minutes: this.querySelector('[data-unit="minutes"]'),
      };
      this.tick();
      this.timer = setInterval(() => this.tick(), 15000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const left = Math.max(0, Math.floor((this.ends - Date.now()) / 60000));
      if (left === 0) {
        clearInterval(this.timer);
        return;
      }
      const pad = (value) => String(value).padStart(2, '0');
      this.units.days.textContent = pad(Math.floor(left / 1440));
      this.units.hours.textContent = pad(Math.floor((left % 1440) / 60));
      this.units.minutes.textContent = pad(left % 60);
    }
  }

  if (!customElements.get('promotion-countdown')) customElements.define('promotion-countdown', PromotionCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-wall-preview"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('size-wall-preview')) {
    customElements.define(
      'size-wall-preview',
      class SizeWallPreview extends HTMLElement {
        static FRAME_CM = 4;
        static GAP_CM = 6;

        connectedCallback() {
          this.scene = this.querySelector('.size-wall__scene');
          this.prints = this.querySelectorAll('.size-wall__print');
          this.verdicts = JSON.parse(this.querySelector('[data-verdicts]').textContent);
          this.verdict = this.querySelector('.size-wall__verdict');
          this.addEventListener('click', this.#onClick);
          this.#update();
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.#onClick);
        }

        #onClick = (event) => {
          const button = event.target.closest('[data-option]');
          if (!button) return;

          for (const option of this.querySelectorAll(`[data-option="${button.dataset.option}"]`)) {
            option.setAttribute('aria-pressed', option === button);
          }
          this.#update();
        };

        #selected(option) {
          return this.querySelector(`[data-option="${option}"][aria-pressed="true"]`);
        }

        #update() {
          const size = this.#selected('size');
          const furniture = this.#selected('furniture');
          const count = Number(this.#selected('count').dataset.value);
          const width = Number(size.dataset.width);

          this.#showArtwork(width / Number(size.dataset.height));
          this.scene.dataset.furniture = furniture.dataset.value;
          this.scene.dataset.count = count;
          this.scene.style.setProperty('--size-wall-print-w', width);
          this.scene.style.setProperty('--size-wall-print-h', size.dataset.height);
          this.scene.style.setProperty('--size-wall-top', furniture.dataset.top);
          this.scene.style.setProperty('--size-wall-gap', furniture.dataset.gap);

          const prefix = count > 1 ? `${count} × ` : '';
          this.querySelector('[data-print-label]').textContent = `${prefix}${size.dataset.value} · ${size.dataset.cm}`;
          this.querySelector('[data-furniture-caption]').textContent = furniture.dataset.caption;

          const spread = count * (width + SizeWallPreview.FRAME_CM) + (count - 1) * SizeWallPreview.GAP_CM;
          const ratio = spread / Number(furniture.dataset.width);
          const [title, text, trioText] = this.verdicts[this.#band(ratio)];

          this.querySelector('[data-verdict-title]').textContent = title;
          this.querySelector('[data-verdict-text]').textContent = count === 3 && trioText ? trioText : text;
          this.querySelector('[data-verdict-coverage]').textContent = this.verdicts.coverage.replace(
            '[percent]',
            Math.round(ratio * 100)
          );
          this.verdict.hidden = false;
        }

        // Each print carries one artwork per shape; show the one closest to the selected size.
        #showArtwork(aspect) {
          const distance = (image) => Math.abs(Number(image.dataset.aspect) - aspect);

          for (const print of this.prints) {
            const images = [...print.querySelectorAll('img[data-aspect]')];
            const closest = images.reduce((best, image) => (distance(image) < distance(best) ? image : best), images[0]);
            for (const image of images) image.toggleAttribute('data-active', image === closest);
          }
        }

        #band(ratio) {
          if (ratio > 1.25) return 'much';
          if (ratio > 0.95) return 'brave';
          if (ratio > 0.75) return 'statement';
          if (ratio >= 0.33) return 'spot';
          if (ratio >= 0.2) return 'works';
          return 'lost';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
